'use strict';
'use client';
import { j as a } from "../../external/react/jsx-runtime.js";
import i from "./media-bar.module.scss.js";
import l from "../../external/classnames/index.js";
import { useWindowDimensions as p } from "../../hooks/useWindowDimensions.js";
import "react";
import "../../external/js-cookie/dist/js.cookie.js";
const d = 230, o = 48;
function f({ images: r, className: n }) {
  const { width: e } = p(), c = {
    "--media-bar-count": r.length,
    "--media-bar-logo-width": `${d}px`,
    "--media-bar-logo-gap": `${o}px`
  }, m = e && e < r.length * (d + o);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: l(i["media-bar"], n),
      "data-animated": m,
      style: c,
      children: [
        /* @__PURE__ */ a.jsx("div", { className: i["media-bar__track"], children: r.map((s, t) => /* @__PURE__ */ a.jsx("div", { className: i["media-bar__item"], children: /* @__PURE__ */ a.jsx("img", { src: s.src, alt: s.alt }) }, t)) }),
        m ? /* @__PURE__ */ a.jsx("div", { className: i["media-bar__track"], "aria-hidden": !0, children: r.map((s, t) => /* @__PURE__ */ a.jsx("div", { className: i["media-bar__item"], children: /* @__PURE__ */ a.jsx("img", { src: s.src, alt: s.alt }) }, t)) }) : null
      ]
    }
  );
}
export {
  f as default
};
